import * as React from 'react';
import '@/components/DynamicTag/index.css';
import { toNumber } from 'lodash';

// 默认行高 20
const DynamicTagLineHeight = 20;
const WMRouter = Mach.requireModule('Router');

export interface IDynamicTagGroup {
  tags: IDynamicTag[];
  lineSpace: number;
  tagSpace: number;
  maxLines: number;
  justifyContent?: string;
  isZeroMargin?: boolean; // 默认false, 为解决item marginRight带来的边距问题
  customHandleOnTagClick?: (tag: IDynamicTag) => void;
}

interface IDynamicTag {
  backgroundColor: string;
  borderColor: string;
  cornerRadius: string[];
  ruleId: number;
  subTags: IDynamicSubTag[];
  height?: string;
  width?: string;
}

interface IDynamicSubTag {
  categoryId: number;
  fontSize: string;
  fontWeight: string;
  horizontalPadding: string;
  verticalPadding: string;
  text: string;
  textColor: string;
  type: number;
  leftSpace: string;
  rightSpace: string;
  height: string;
  width: string;
  url: string;
  backgroundUrl: string;
  backgroundColor: string;
  fontFace: string;
  cornerRadius: string[];
  gradientColor: {
    direction: number;
    endColor: string;
    startColor: string;
  };
  lineNumbers: number;
}

function adativeSizeValue(style: Record<string, string | number>) {
  const newStyle = {};

  Object.entries(style).forEach(([key, val]) => {
    if (typeof val === 'number' || isNaN(parseInt(val))) {
      newStyle[key] = val;
    } else {
      newStyle[key] = `${parseInt(val)}px`;
    }
  });

  return newStyle;
}

export class DynamicTagGroup extends React.PureComponent<IDynamicTagGroup> {
  render() {
    const {
      tags, maxLines = 1, lineSpace = 0, tagSpace = 4, justifyContent = 'flex-start', isZeroMargin = false
    } = this.props;
    // 取最大行高，默认高度为20
    let maxLineHeight = DynamicTagLineHeight;
    let hasBorderNum = 0;
    tags.forEach((tag) => {
      if (tag?.height && toNumber(tag?.height) > maxLineHeight) {
        maxLineHeight = toNumber(tag.height);
      }
      if (tag?.borderColor) {
        hasBorderNum += 1;
      }
    });

    // maxlines 为 0，自动撑高，maxlines不为0 给最大高度
    const maxHeight = maxLines === 0 ? 'auto' : (maxLines * (maxLineHeight + lineSpace)) + (hasBorderNum > 0 && Mach.env.isAndroid ? hasBorderNum * 1 : 0);
    // ----- mpweb适配origin -----
    // ----- mpweb适配change -----
    const tagKeyOccurrences = new Map<number, number>();
    // ----- mpweb适配       -----
    return (
      <view className="tag-group-container-warp">
        <view
          className="tag-group-container"
          style={adativeSizeValue({
            maxHeight,
            justifyContent,
            marginTop: -lineSpace, // 每个item 都有marginTop 需容器减去第一行 marginTop
            marginRight: isZeroMargin ? -tagSpace : 0, // 每个item 都有marginRight间隔  需容器增加 marginRight, 解决容积减少问题 和 多余marginRight 问题
          })}
        >
          {/* ----- mpweb适配origin ----- */}
          {/* {tags.map((tag, index) => this.renderTag(tags.length, index, tag, lineSpace, 0, tagSpace, isZeroMargin))} */}
          {/* ----- mpweb适配change ----- */}
          {tags.map((tag, index) => {
            const occurrence = tagKeyOccurrences.get(tag.ruleId) || 0;
            tagKeyOccurrences.set(tag.ruleId, occurrence + 1);
            return (
              <React.Fragment key={`${tag.ruleId}:${occurrence}`}>
                {this.renderTag(tags.length, index, tag, lineSpace, 0, tagSpace, isZeroMargin)}
              </React.Fragment>
            );
          })}
          {/* ----- mpweb适配       ----- */}
        </view>
      </view>
    );
  }
  handleOnTagClick(tag) {
    const { scheme } = tag;
    const { customHandleOnTagClick } = this.props;
    customHandleOnTagClick?.(tag);
    if (scheme && WMRouter) {
      WMRouter.navigateTo(scheme);
    }
  }

  renderTag = (tagsLength: number, index: number, tag: IDynamicTag, lineSpace: number, warpMarginLeft: number, warpMarginRight: number, isZeroMargin: boolean) => {
    const { cornerRadius } = tag;
    // ----- mpweb适配origin -----
    // ----- mpweb适配change -----
    const subTagKeyOccurrences = new Map<string, number>();
    // ----- mpweb适配       -----
    return (
      <view
        className="tag-container"
        style={{
          height: tag?.height || DynamicTagLineHeight,
          width: tag?.width || 'auto',
          backgroundColor: tag?.backgroundColor || '#00000000',
          borderColor: tag?.borderColor || '#00000000',
          borderWidth: tag?.borderColor ? '1px' : 0,
          borderTopLeftRadius: cornerRadius ? cornerRadius[0] : 0,
          borderTopRightRadius: cornerRadius ? cornerRadius[1] : 0,
          borderBottomRightRadius: cornerRadius ? cornerRadius[2] : 0,
          borderBottomLeftRadius: cornerRadius ? cornerRadius[3] : 0,
          marginBottom: Mach.env.isAndroid && tag?.borderColor ? 0.5 : 0,
          marginTop: lineSpace + (Mach.env.isAndroid && tag?.borderColor ? 0.5 : 0),
          marginLeft: warpMarginLeft,
          marginRight: !isZeroMargin && (tagsLength === 1 || tag?.width === '100%') ? 0 : warpMarginRight
        }}
        onClick={() => { this.handleOnTagClick.bind(this)(tag); }}
      >
        {/* ----- mpweb适配origin ----- */}
        {/* tag.subTags?.map((subTag: IDynamicSubTag) => {
          if (subTag.type === 0 || subTag.type === 3) return this.renderTextSubTag(subTag);
          if (subTag.type === 1) return this.renderImageSubTag(subTag);
          if (subTag.type === 2) return this.renderSeperatorSubTag(subTag);
          return (<view />);
        }) */}
        {/* ----- mpweb适配change ----- */}
        {tag.subTags?.map((subTag: IDynamicSubTag) => {
          const identity = `${subTag.categoryId ?? 'subtag'}-${subTag.type}-${subTag.text || subTag.url || subTag.backgroundUrl || 'content'}`;
          const occurrence = subTagKeyOccurrences.get(identity) || 0;
          subTagKeyOccurrences.set(identity, occurrence + 1);
          let subTagView;
          if (subTag.type === 0 || subTag.type === 3) {
            subTagView = this.renderTextSubTag(subTag);
          } else if (subTag.type === 1) {
            subTagView = this.renderImageSubTag(subTag);
          } else if (subTag.type === 2) {
            subTagView = this.renderSeperatorSubTag(subTag);
          } else {
            subTagView = (<view />);
          }
          return (
            <React.Fragment
              key={`${identity}:${occurrence}`}
            >
              {subTagView}
            </React.Fragment>
          );
        })}
        {/* ----- mpweb适配       ----- */}
      </view>
    );
  }

  renderTextSubTag = (subTag: IDynamicSubTag) => {
    const { cornerRadius } = subTag;
    if (subTag.backgroundUrl) {
      return (
        <view
          className="sub-text-tag-container"
          style={{
            height: subTag.height || DynamicTagLineHeight,
            borderTopLeftRadius: cornerRadius ? cornerRadius[0] : 0,
            borderTopRightRadius: cornerRadius ? cornerRadius[1] : 0,
            borderBottomRightRadius: cornerRadius ? cornerRadius[2] : 0,
            borderBottomLeftRadius: cornerRadius ? cornerRadius[3] : 0,
          }}
        >
          <image className="sub-text-background-image" src={subTag.backgroundUrl} />
          <text
            className="sub-text-tag"
            style={{
              height: subTag.height || DynamicTagLineHeight,
              color: subTag.textColor || '#00000000',
              marginLeft: subTag.leftSpace || 0,
              marginRight: subTag.rightSpace || 0,
              fontFamily: subTag.fontFace,
              fontSize: subTag.fontSize || 11,
              paddingLeft: subTag.horizontalPadding || 0,
              paddingRight: subTag.horizontalPadding || 0,
              backgroundColor: subTag.gradientColor ? `linear-gradient(${subTag.gradientColor.direction === 0 ? 'to right' : 'to bottom'}, ${subTag.gradientColor.startColor}, ${subTag.gradientColor.endColor})` : subTag.backgroundColor ? subTag.backgroundColor : '#00000000',
              flexShrink: subTag.type === 3 ? 1 : 0,
              fontWeight: subTag.fontFace ? (subTag.fontWeight || 'normal') : 'normal'
            }}
            content={subTag.text}
          />
        </view>
      );
    } else {
      return (
        <text
          className="sub-text-tag"
          style={{
            height: subTag.height || DynamicTagLineHeight,
            color: subTag.textColor || '#00000000',
            marginLeft: subTag.leftSpace || 0,
            marginRight: subTag.rightSpace || 0,
            fontFamily: subTag.fontFace,
            fontSize: subTag.fontSize || 11,
            borderTopLeftRadius: cornerRadius ? cornerRadius[0] : 0,
            borderTopRightRadius: cornerRadius ? cornerRadius[1] : 0,
            borderBottomRightRadius: cornerRadius ? cornerRadius[2] : 0,
            borderBottomLeftRadius: cornerRadius ? cornerRadius[3] : 0,
            paddingLeft: subTag.horizontalPadding || 0,
            paddingRight: subTag.horizontalPadding || 0,
            backgroundColor: subTag.gradientColor ? `linear-gradient(${subTag.gradientColor.direction === 0 ? 'to right' : 'to bottom'}, ${subTag.gradientColor.startColor}, ${subTag.gradientColor.endColor})` : subTag.backgroundColor ? subTag.backgroundColor : '#00000000',
            flexShrink: subTag.type === 3 ? 1 : 0,
            fontWeight: subTag.fontFace ? (subTag.fontWeight || 'normal') : 'normal'
          }}
          content={subTag.text}
        />
      );
    }
  }

  renderImageSubTag = (subTag: IDynamicSubTag) => {
    const { cornerRadius } = subTag;
    return (
      <view
        style={{
          height: subTag.height || 0,
          width: subTag.width || 0,
          marginLeft: subTag.leftSpace || 0,
          marginRight: subTag.rightSpace || 0,
          borderTopLeftRadius: cornerRadius ? cornerRadius[0] : 0,
          borderTopRightRadius: cornerRadius ? cornerRadius[1] : 0,
          borderBottomRightRadius: cornerRadius ? cornerRadius[2] : 0,
          borderBottomLeftRadius: cornerRadius ? cornerRadius[3] : 0,
          paddingLeft: subTag.horizontalPadding || 0,
          paddingRight: subTag.horizontalPadding || 0,
        }}
      >
        <image
          className="sub-image-tag"
          src={subTag.url}
        />
      </view>
    );
  }

  renderSeperatorSubTag = (subTag: IDynamicSubTag) => {
    const { cornerRadius } = subTag;
    return (
      <view
        style={{
          height: subTag.height || 0,
          width: subTag.width || 0,
          borderTopLeftRadius: cornerRadius ? cornerRadius[0] : 0,
          borderTopRightRadius: cornerRadius ? cornerRadius[1] : 0,
          borderBottomRightRadius: cornerRadius ? cornerRadius[2] : 0,
          borderBottomLeftRadius: cornerRadius ? cornerRadius[3] : 0,
          marginLeft: subTag.leftSpace || 0,
          marginRight: subTag.rightSpace || 0,
          paddingLeft: subTag.horizontalPadding || 0,
          paddingRight: subTag.horizontalPadding || 0,
          backgroundColor: subTag.gradientColor ? `linear-gradient(${subTag.gradientColor.direction === 0 ? 'to right' : 'to bottom'}, ${subTag.gradientColor.startColor}, ${subTag.gradientColor.endColor})` : subTag.backgroundColor ? subTag.backgroundColor : '',
          flexShrink: 0,
        }}
      />
    );
  }
}
